// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"jo-z","badgeLink":"ko-z","category":"lo-z"};